import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";
import axAPI from "../../../api/axios-instance";
import { DataProvider } from "@refinedev/core";
import qs from "qs";

export const matchesDescriptionDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    update: async ({
      resource,
      id,
      variables,
      meta,
    }: {
      resource: string;
      id: string | number;
      variables: { description: string };
      meta: { matchId: number; leagueId: number };
    }) => {
      const removeUrl = "/cms/match/removeDescription";
      const addUrl = "/cms/match/addDescription";
      const { matchId, leagueId } = meta;
      try {
        await httpClient.get(`${removeUrl}?${qs.stringify({ matchId })}`);
        const { data } = await httpClient.post(addUrl, {
          matchId,
          leagueId,
          title: "",
          description: variables.description,
        });
        return { data };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    create: async ({
      resource,
      variables,
      meta,
    }: {
      resource: string;
      variables: { description: string };
      meta: { matchId: number; leagueId: number };
    }) => {
      const addUrl = "/cms/match/addDescription";
      const { matchId, leagueId } = meta;
      try {
        const { data } = await httpClient.post(addUrl, {
          matchId,
          leagueId,
          title: "",
          description: variables.description,
        });
        return { data };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    deleteOne: async ({ resource, id, meta }) => {
      const url = "/cms/match/removeDescription";
      const { matchId } = meta as { matchId: number };
      try {
        const { data } = await httpClient.get(
          `${url}?${qs.stringify({ matchId })}`
        );
        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
  };
